import type { MoveCategory } from "@rosette/ts/src/business/analysis/MoveCategory.js";
import { getMoveCategoryIcon } from "@rosette/web_components/src/icon/analysis/getMoveCategoryIcon.js";
import Image from "next/image";
import type { CSSProperties } from "react";


interface MoveCategoryIconProps {
    moveCategory: MoveCategory;
    className?: string;
    style?: CSSProperties;
}


export function MoveCategoryIcon({ moveCategory, className, style }: MoveCategoryIconProps) {
    const icon = getMoveCategoryIcon(moveCategory);
    return (
        <Image
            className={className}
            src={icon}
            alt={moveCategory.name}
            style={style} />
    );
}
